import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { APIService, KPI } from '../../@core/api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { NbDialogService } from '@nebular/theme';
import { PowerpointReportingDialogComponent } from '../../@theme/components';
import { ChartFiltersService } from './chart-filters.service';
import { YearsService } from './years.service';

export interface Dimensions {
  width: number;
  height: number;
}
@Injectable()
export class ReportsService {
  constructor(
    private http: HttpClient,
    private api: APIService,
    private yearsService: YearsService,
    private chartFiltersService: ChartFiltersService,
    private nbDialogService: NbDialogService,
  ) { }


  public isAnyReportDownloading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public get userReportTemplates$(): Observable<KPI.ReportTemplate[]> {
    return this.api.get_available_report_templates();
  }

  public get allReportTemplates$(): Observable<KPI.ReportTemplate[]> {
    return this.api.get_available_report_templates({all: true});
  }

  /**
 * POWERPOINT REPORT DOWNLOAD
 */
  public downloadReport(inputData: KPI.ReportTemplateInputData, templateId: number): Observable<void> {
    return this.http.request(
      'POST',
      `${environment.backendHost}/reporting/generate-report/`,
      {
        body: {
          input_data: inputData,
          template_id: templateId,
        },
        responseType: 'blob',
        observe: 'response',
      },
    ).pipe(
      map((response) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        const fileName = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : "file";

        const blob = new Blob([response.body], { type: response.headers.get('content-type') });

        const downloadURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadURL;
        a.download = fileName;
        a.click();

        return downloadURL;
      }),
      map((downloadURL) => window.URL.revokeObjectURL(downloadURL)),
    );
  }

  public showPerimeterReportTemplateDialog(template: KPI.ReportTemplate, perimeter: KPI.Perimeter): void {
    combineLatest([
      this.yearsService.latestYears$,
      this.chartFiltersService.filter$('energyConsumptionType', false).pipe(map((e) => String(e) as KPI.ConsumptionType)),
      this.chartFiltersService.filter$('carbonConsumptionType', false).pipe(map((e) => String(e) as KPI.ConsumptionType)),
    ]).pipe(first()).subscribe(([
      [start_year, end_year], energy_consumption_key, carbon_consumption_key,
    ]) => {
      const inputData: KPI.ReportTemplateInputData = {
        perimeter_id: perimeter.id,
        start_year,
        end_year,
        energy_consumption_key,
        carbon_consumption_key,
      }

      this.nbDialogService.open(
        PowerpointReportingDialogComponent,
        {
          closeOnBackdropClick: false,
          context: {
            inputData,
            template,
          }
        }
      );
    })
  }

}
